// BlankLayout.jsx
import React from "react";

export default function BlankLayout() {
  return (
    <div className="main-div-with-bg w-full h-full min-h-screen" />
  );
}